import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import LanguageIconSvg from '../../../assets/icons/icon-my-page-settings-language.svg?react';
import LogoutIconSvg from '../../../assets/icons/icon-my-page-settings-logout.svg?react';
import PersonalDataIconSvg from '../../../assets/icons/icon-my-page-settings-personal-data.svg?react';
import SecurityIconSvg from '../../../assets/icons/icon-my-page-settings-security.svg?react';
import SupportIconSvg from '../../../assets/icons/icon-my-page-settings-support.svg?react';

import { MyPageSettingsList } from './my-page-settings-list';

type MyPageSettingsOverviewScreenProps = {
  onLogout: () => void;
  onOpenLanguage: () => void;
  onOpenPersonalData: () => void;
  onOpenSecurity: () => void;
  onOpenSupport?: () => void;
};

const Screen = styled.div.attrs({
  'data-ui': 'my-page-settings-overview-screen',
})`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(28)};
  padding-bottom: ${({ theme }) => theme.scale.px(20)};
`;

function createIconSlot(Icon: typeof SupportIconSvg) {
  return <Icon aria-hidden />;
}

export function MyPageSettingsOverviewScreen({
  onLogout,
  onOpenLanguage,
  onOpenPersonalData,
  onOpenSecurity,
  onOpenSupport,
}: MyPageSettingsOverviewScreenProps) {
  const { t } = useTranslation();

  return (
    <Screen>
      <MyPageSettingsList
        title={t('myPageSettings.sections.settings')}
        items={[
          {
            icon: createIconSlot(PersonalDataIconSvg),
            key: 'personal-data',
            label: t('myPageSettings.rows.personalData'),
            onPress: onOpenPersonalData,
          },
          {
            icon: createIconSlot(SecurityIconSvg),
            key: 'security',
            label: t('myPageSettings.rows.security'),
            onPress: onOpenSecurity,
          },
          {
            icon: createIconSlot(LanguageIconSvg),
            key: 'language',
            label: t('myPageSettings.rows.language'),
            onPress: onOpenLanguage,
          },
        ]}
      />

      <MyPageSettingsList
        title={t('myPageSettings.sections.help')}
        items={[
          {
            icon: createIconSlot(SupportIconSvg),
            key: 'support',
            label: t('myPageSettings.rows.support'),
            onPress: onOpenSupport,
            showChevron: Boolean(onOpenSupport),
          },
          {
            icon: createIconSlot(LogoutIconSvg),
            key: 'logout',
            label: t('myPageSettings.rows.logout'),
            onPress: onLogout,
          },
        ]}
      />
    </Screen>
  );
}
